import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_CONFIG } from '../../../config/app.config';

interface OnboardingOverlayCardProps {
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

/** Shared card shell for page overlays (560px, header / body / footer). */
const OnboardingOverlayCard: React.FC<OnboardingOverlayCardProps> = ({
  title,
  children,
  footer,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: colors.border,
          px: 3,
          py: 3,
        }}
      >
        <Typography variant="subtitle1" color="text.primary" fontWeight={600}>
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          p: 4,
          overflow: 'auto',
        }}
      >
        {children}
      </Box>

      {footer && (
        <Box
          sx={{
            borderTop: 1,
            borderColor: colors.border,
            px: 3,
            py: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 2,
          }}
        >
          {footer}
        </Box>
      )}
    </>
  );
};

export default OnboardingOverlayCard;
